<script>
import FormGroup from '@/pages/components/form/horizontal/form-group'
import formInput from "@/mixins/shared/formInput";
import Input from "@/pages/components/form/input-only/input";

export default {
	mixins: [formInput],
	components: {FormGroup, Input},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>
<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label"><slot name="label" /></template>
		<template #label v-if="!$slots.label">{{ label }}</template>
		<Input
			v-bind="$attrs"
			:form="form"
			:name="name"
			type="email"
			:id="renderedId"
			:model-value="modelValue"
			@update:modelValue="changeModelValueTo"
		>
			<template #addonbefore>
				<slot name="addonbefore">
					<i class="bi bi-envelope"></i>
				</slot>
			</template>
			<template #addonafter v-if="$slots.addonafter"><slot name="addonafter" /></template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</Input>
	</FormGroup>
</template>